module.exports = __webpack_public_path__ + "img/ore_orocketsgame.d55218c.png";